import { reactive, ref, computed } from '@vue/composition-api'
import store from '@/store'
import * as common from '@/util/common'
import * as apiProfile from '@/api/profile'
import * as apiKnowledge from '@/api/knowledge'

/**
 * プロフィールウィンドウ
 */
export const getGroup = (props, context) => {

  const group1 = reactive({

    id: 0, // 利用者ID
    name: '', // 利用者名
    email: '', // 利用者メールアドレス
    authDisp: computed(() => {
      let label = '-'
      if (store.state.profile.auth === 1) {
        label = '管理者' 
      } else if (store.state.profile.auth === 2) {
        label = '利用者'
      }
      return label
    }),
    product_name_lists: [], // 付与ライセンスリスト

    alert_flg: 9, // アラート通知フラグ(デフォルト：9=設定なし)
    alert_flg_list: [
      { value: 0, name: '通知とメール'},
      { value: 1, name: '通知のみ'},
      { value: 2, name: 'メールのみ'},
      { value: 9, name: '設定しない'}
    ],
    alert_flgDisp: computed(() => {
      let value = ''
      for (let i = 0; i < group1.alert_flg_list.length; i++) {
        if (group1.alert_flg === group1.alert_flg_list[i].value) {
          value = group1.alert_flg_list[i].name
          break
        }
      }
      return value
    }),

    alert_books: [], // アラート書籍リスト(IDと名称のオブジェクトのリスト)
    // 書籍の更新情報欄に表示する書籍名リスト
    alert_booksDisp: computed(() => {
      const alertBooks = group1.alert_books
      const bookNames = []
      for (let i = 0; i < alertBooks.length; i++) {
        const bookName = alertBooks[i].name ?? ''
        if (bookName !== '') {
          bookNames.push(bookName)
        }
      }
      return bookNames.join('、')
    }),
    alert_tags: [], // アラートタグリスト（名称のリスト）
    error_alert_tags: '', // アラートタグエラーメッセージ
    // ファイルID
    user_icon: computed(() => {
      return store.state.profile.user_icon
    }),
    user_icon_image: computed(() => {
      return store.state.profile.user_icon_image
    }),
    template: 0, // テンプレート

    backgroundImage: computed(() => {
      const template = store.state.profile.template
      return common.getTemplateImage(template)
    }), // 背景画像

    alert_tag: '', // アラートタグ入力欄（データバインディング用）

    // 最新ナレッジ関係のコンテンツ（気になるキーワード）表示フラグ
    isKnowledgeContentsShown: false,

    /**
     * 初期表示
     */
    init: () => {
      // プロフィール情報を変更後、リロードした場合に最新情報が表示されるよう、
      // APIからプロフィール情報を取得しなおす
      store
        .dispatch('profile/fetch')
        .then(() => {
          store.dispatch('profile/getUserImage')

          // プロフィール情報はストアに保持されているので、ストアから取得
          group1.id = store.state.profile.id
          group1.name = store.state.profile.name
          group1.email = store.state.profile.email
          group1.product_name_lists = store.state.profile.product_name_lists
          group1.alert_flg = store.state.profile.alert_flg
          group1.alert_books = store.state.profile.alert_books
          group1.alert_tags = store.state.profile.alert_tags
          group1.template = store.state.profile.template
        })

      // 単体書籍のみのライセンスユーザーについて、
      // ［最新ナレッジ］の表記を非表示にする対応。
      // → 最新ナレッジ一覧が0件の場合非表示にする
      // 最新ナレッジキーワード検索数取得APIをコール
      const params = {}
      apiKnowledge.searchCount(params)
        .then(response => {
          if (response) {
            const { data } = response

            const count = data.count ?? 0
            if (count > 0) {
              // 最新ナレッジが取得できる場合は、「気になるキーワード」の設定欄を表示
              group1.isKnowledgeContentsShown = true
            }
          }
        })
    },

    /**
     * アップデート通知の配信方法を変更した場合
     * (ラジオボタンのチェックを変更した場合)
     */
    onAlertFlgChanged: () => {

      // ストアデータを更新
      store.dispatch('profile/setAlertFlg', group1.alert_flg)

      // プロフィール更新APIをコール
      const params = {}
      params.alert_flg = group1.alert_flg

      apiProfile.update(params)
        .then(response => {
          if (response) {
            const { data } = response

            if (data.status === 0) {
              store.dispatch('common/showToast', {
                text: 'アップデート通知設定を更新しました'
              })
            }
          }
        })
    },

    /**
     * アラート書籍の設定（更新）
     */
    setAlertBooks: (alertBooks) => {

      group1.alert_books = alertBooks
      store.dispatch('profile/setAlertBooks', alertBooks)

      // プロフィール更新APIに渡すためのリクエストパラメータを生成
      const bookIds = []

      for (let i = 0; i < group1.alert_books.length; i++) {
        const bookId = group1.alert_books[i].id
        bookIds.push(bookId)
      }

      // プロフィール更新APIをコール
      const params = {}
      params.alert_books = bookIds

      apiProfile.update(params)
        .then(response => {
          if (response) {
            const { data } = response

            if (data.status === 0) {
              store.dispatch('common/showToast', {
                text: 'アップデート通知設定を更新しました'
              })
            }
          }
        })
    },

    /**
     * アラートタグの追加(+)ボタンを押下した場合
     */
    onAddAlertTagButtonClicked: (inputAlertTag) => {

      inputAlertTag = inputAlertTag.trim()

      group1.error_alert_tags = ''

      if (inputAlertTag.length <= 1) {
        // キーワードは2文字以上
        group1.error_alert_tags = 'キーワードは2文字以上で入力してください。'
        return
      }

      if (group1.alert_tags.length >= 10) {
        // キーワードは最大10点まで設定可能
        group1.error_alert_tags = 'キーワードは最大10点まで設定可能です。'
        return
      }

      if (inputAlertTag !== '') {
        // 同じキーワードが存在するかチェック
        let exists = false
        for (let i = 0; i < group1.alert_tags.length; i++) {
          if (inputAlertTag === group1.alert_tags[i]) {
            exists = true
            break
          }
        }
        if (!exists) {
          // 同じキーワードが存在しなかった場合のみ追加
          group1.alert_tags.push(inputAlertTag)
          group1.alert_tag = ''

          // ストアデータを更新
          store.dispatch('profile/setAlertBooks', group1.alert_tags)

          // プロフィール更新APIをコール
          const params = {}
          params.alert_tags = group1.alert_tags

          apiProfile.update(params)
            .then(response => {
              if (response) {
                const { data } = response

                if (data.status === 0) {
                  store.dispatch('common/showToast', {
                    text: 'アップデート通知設定を更新しました'
                  })
                }
              }
            })
        }
      }
    },

    /**
     * アラートタグの削除(×)ボタンを押下した場合
     */
    onDeleteAlertTagButtonClicked: (targetTag) => {

      const newAlertTags = []
      for (let i = 0; i < group1.alert_tags.length; i++) {
        if (group1.alert_tags[i] !== targetTag) {
          newAlertTags.push(group1.alert_tags[i])
        }
      }
      group1.alert_tags = newAlertTags

      // ストアデータを更新
      store.dispatch('profile/setAlertBooks', group1.alert_tags)

      // プロフィール更新APIをコール
      const params = {}
      params.alert_tags = (group1.alert_tags.length === 0) ? [''] : group1.alert_tags

      apiProfile.update(params)
        .then(response => {
          if (response) {
            const { data } = response

            if (data.status === 0) {
              store.dispatch('common/showToast', {
                text: 'アップデート通知設定を更新しました'
              })
            }
          }
        })
    }

  })

  return group1
}
